import microuniversoApi from "app/api/microuniversoApi";
import { DadosFaturamento } from "app/types/FaturamentoOutrasSaidas";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { Faturamento } from "./Faturamento";

export type FaturamentoContainerProps = {
    orcamento: IOrcamento
}


export const FaturamentoContainer = (props: FaturamentoContainerProps) => {

    const [dadosFaturamento, setDadosFaturamento] = useState<DadosFaturamento>({})

    const onObterDadosFaturamento = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.obterDadosFaturamento(props.orcamento.IdentificadorOrcamento);
            setDadosFaturamento(resultado)
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onSalvarFaturamento = async (dados: DadosFaturamento) => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.salvarDadosFaturamentoOutrasSaidas(props.orcamento.IdentificadorOrcamento, dados);
            setDadosFaturamento({
                ...dadosFaturamento, CodigoDepositoDestino: resultado.CodigoDepositoDestino,
                CodigoMensagemTributaria: resultado.CodigoMensagemTributaria,
                MercadoriaComRetorno: resultado.MercadoriaComRetorno,
                OperacaoTributada: resultado.OperacaoTributada
            })
            !("HasError" in resultado) && globalMU.showSuccessMessage("Dados de faturamento atualizados com sucesso.");
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    useEffect(() => {
        onObterDadosFaturamento();
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={["Faturamento"]}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={false}
                id="breadcrumb-faturamento"
            />

            <Faturamento
                somenteLeitura={props.orcamento.SomenteLeitura}
                dadosFaturamento={dadosFaturamento}
                onAplicar={onSalvarFaturamento}
                onErrorValidacao={(mensagemErro) => globalMU.showErrorMessage(mensagemErro)} />
        </>
    );
}